module.exports = __webpack_public_path__ + "static/media/[抓狂]@2x.e8e3ad3b.png";